

export function makePriceFormat(inputNumber) {
    return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getYoutubeId(url) {
    if(url != null){
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        } else {
            return "";
        }
    }else{
        return "";
    }
}





// WEBPACK FOOTER //
// ./src/js/common.js